import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from "@mui/material";

import { useEffect, useState } from "react";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

export default function RelatedFieldComponent({
  dataFormFields,
  setRelatedParentField,
  setFieldMeta, // optional if you later want to push meta up
  initialParentField, // ✅ add
  initialRelatedOptions,
}) {
  // ===== MOVED STATES (exact ones used here) =====
  const [relatedParentField, setRelatedParentFieldInner] = useState(null);
  const [relatedOptions, setRelatedOptions] = useState({});
  const [selectedRelatedOptionIndex, setSelectedRelatedOptionIndex] = useState(null);
  const [relatedParentOption, setRelatedParentOption] = useState(null);
  const [relatedChildOptions, setRelatedChildOptions] = useState(null);
  const [openAddRelatedOptionsDialog, setOpenAddRelatedOptionsDialog] = useState(false);

  const [childOptionsList, setChildOptionsList] = useState([]);
  const [openChildOptionDialog, setOpenChildOptionDialog] = useState(false);
  const [childOptionName, setChildOptionName] = useState("");
  const [childOptionValue, setChildOptionValue] = useState("");

  useEffect(() => {
    console.log(dataFormFields);
    setRelatedParentField(relatedParentField);
  }, [relatedParentField]);

  useEffect(() => {
    if (initialParentField) {
      setRelatedParentFieldInner(String(initialParentField));
    }

    if (initialRelatedOptions) {
      setRelatedOptions(initialRelatedOptions);
    }
  }, [initialParentField, initialRelatedOptions]);

  useEffect(() => {
    if (setFieldMeta) {
      setFieldMeta({
        related_options: relatedOptions,
      });
    }
  }, [relatedOptions]);

  // ===== YOUR EXISTING FUNCTION (moved exactly) =====
  function buildRelatedOptionsTable() {
    const items = [];
    Object.keys(relatedOptions).forEach((key) => {
      items.push(
        <TableRow>
          <TableCell>
            <MDTypography variant="subtitle2" fontSize={14}>
              {key}
            </MDTypography>
            <MDTypography variant="subtitle2" fontSize={10}>
              <MDButton
                size="small"
                iconOnly
                onClick={() => {
                  setRelatedParentOption(key);

                  // 👇 convert existing string → structured list
                  const existing = relatedOptions[key] || "";

                  const arr = existing
                    .split(",\n")
                    .filter(Boolean)
                    .map((line) => {
                      const [name, value] = line.split(":");
                      return { name, value };
                    });

                  setChildOptionsList(arr);

                  setOpenAddRelatedOptionsDialog(true);
                }}
              >
                <Icon color="warning">edit</Icon>
              </MDButton>
              &nbsp;&nbsp;
              <MDButton
                size="small"
                iconOnly
                onClick={() => {
                  if (window.confirm("Delete?") === true) {
                    const tmp = relatedOptions;
                    delete tmp[key];
                    setRelatedOptions(tmp);
                  }
                }}
              >
                <Icon color="error">delete</Icon>
              </MDButton>
            </MDTypography>
          </TableCell>
          <TableCell>
            <MDTypography variant="subtitle2" fontSize={12}>
              {relatedOptions[key]}
            </MDTypography>
          </TableCell>
        </TableRow>
      );
    });
    return items;
  }

  function syncChildOptionsToString(list) {
    let str = "";

    list.forEach((opt) => {
      const name = opt.name?.trim();
      const value = opt.value?.trim();

      if (!name) return;

      const val = value || name;
      str += `${name}:${val},\n`;
    });

    setRelatedChildOptions(str);
  }

  return (
    <>
      <MDBox>
        <MDBox mt={5}>
          <FormControl sx={{ minWidth: 120, width: "100%" }}>
            <InputLabel>Related Parent Field</InputLabel>
            <Select
              label="Related Parent Field"
              disabled={!!initialParentField}
              onChange={(e) => {
                setRelatedParentFieldInner(e.target.value);
              }}
              sx={{ padding: "12px", paddingLeft: "3px" }}
              value={relatedParentField || ""}
            >
              {dataFormFields.length > 0 &&
                dataFormFields.map((record) => {
                  if (record.data_field.field_type === "select") {
                    return <MenuItem value={`${record.reference}`}>{record.display_name}</MenuItem>;
                  }
                  return null;
                })}
            </Select>
          </FormControl>
        </MDBox>

        <MDBox mt={3} mb={3}>
          <MDBox p={1} display="flex" justifyContent="space-between">
            <MDTypography variant="h6">Related Options</MDTypography>
            <MDButton
              variant="outlined"
              color="dark"
              size="small"
              iconOnly
              onClick={() => {
                setSelectedRelatedOptionIndex(null);
                setRelatedParentOption(null);
                setRelatedChildOptions(null);
                setChildOptionsList([]);
                setOpenAddRelatedOptionsDialog(true);
              }}
            >
              <Icon>add</Icon>
            </MDButton>
          </MDBox>

          <Table>
            <TableBody>
              <TableRow>
                <TableCell>
                  <MDTypography variant="h6" fontSize={14}>
                    Parent Value
                  </MDTypography>
                </TableCell>
                <TableCell>
                  <MDTypography variant="h6" fontSize={14}>
                    Related Options
                  </MDTypography>
                </TableCell>
              </TableRow>
              {buildRelatedOptionsTable()}
            </TableBody>
          </Table>
        </MDBox>
      </MDBox>

      <Dialog open={openChildOptionDialog} fullWidth maxWidth="xs">
        <DialogTitle>Add Related Option</DialogTitle>

        <DialogContent>
          <MDBox mt={2}>
            <MDInput
              label="Name"
              fullWidth
              value={childOptionName}
              onChange={(e) => setChildOptionName(e.target.value)}
            />
          </MDBox>

          <MDBox mt={2}>
            <MDInput
              label="Value (optional)"
              fullWidth
              value={childOptionValue}
              onChange={(e) => setChildOptionValue(e.target.value)}
            />
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton onClick={() => setOpenChildOptionDialog(false)}>Cancel</MDButton>

          <MDButton
            color="info"
            onClick={() => {
              if (!childOptionName?.trim()) return;

              const newList = [
                ...childOptionsList,
                {
                  name: childOptionName.trim(),
                  value: childOptionValue.trim(),
                },
              ];

              setChildOptionsList(newList);
              syncChildOptionsToString(newList);
              setOpenChildOptionDialog(false);
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* ===== DIALOG (unchanged) ===== */}
      <Dialog open={openAddRelatedOptionsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Related Options</MDBox>
        </DialogTitle>

        <DialogContent>
          <MDBox mt={2} mb={3}>
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel>Parent Value</InputLabel>
              <Select
                label="Parent Value"
                value={relatedParentOption || ""}
                onChange={(e) => setRelatedParentOption(e.target.value)}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                {dataFormFields
                  .find((f) => f.reference === relatedParentField)
                  ?.options?.map((opt) => (
                    <MenuItem value={opt.value}>{opt.name}</MenuItem>
                  ))}
              </Select>
            </FormControl>

            <MDBox mt={2}>
              <MDBox mt={2}>
                {/* HEADER */}
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <MDTypography variant="h6" fontSize={14}>
                    Related Options
                  </MDTypography>

                  <MDButton
                    size="small"
                    variant="outlined"
                    color="dark"
                    iconOnly
                    onClick={() => {
                      setChildOptionName("");
                      setChildOptionValue("");
                      setOpenChildOptionDialog(true);
                    }}
                  >
                    <Icon>add</Icon>
                  </MDButton>
                </MDBox>

                {/* EMPTY STATE */}
                {childOptionsList.length === 0 && (
                  <MDBox
                    mt={2}
                    p={2}
                    sx={{ border: "1px dashed #ccc", borderRadius: "8px", cursor: "pointer" }}
                    onClick={() => {
                      setChildOptionName("");
                      setChildOptionValue("");
                      setOpenChildOptionDialog(true);
                    }}
                  >
                    <MDTypography variant="button" align="center" display="block">
                      Click to add related options
                    </MDTypography>
                  </MDBox>
                )}

                {/* LIST */}
                {childOptionsList.map((opt, idx) => (
                  <MDBox
                    key={idx}
                    mt={0.5}
                    px={1}
                    sx={{
                      border: "1px solid #eee",
                      borderRadius: "6px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="caption" display="block">
                        {opt.name} | {opt.value || opt.name}
                      </MDTypography>
                    </MDBox>

                    <MDButton
                      iconOnly
                      size="small"
                      onClick={() => {
                        const tmp = childOptionsList.filter((_, i) => i !== idx);
                        setChildOptionsList(tmp);
                        syncChildOptionsToString(tmp);
                      }}
                    >
                      <Icon color="error">delete</Icon>
                    </MDButton>
                  </MDBox>
                ))}
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton
            onClick={() => {
              setSelectedRelatedOptionIndex(null);
              setRelatedParentOption(null);
              setRelatedChildOptions(null);
              setOpenAddRelatedOptionsDialog(false);
            }}
          >
            Cancel
          </MDButton>

          <MDButton
            onClick={() => {
              if (!relatedParentOption || !relatedChildOptions) return;

              const tmp = relatedOptions;

              if (selectedRelatedOptionIndex !== null) {
                delete tmp[selectedRelatedOptionIndex];
              }

              tmp[relatedParentOption] = relatedChildOptions;

              setRelatedOptions(tmp);
              setOpenAddRelatedOptionsDialog(false);

              // optional: push up
              if (setFieldMeta) {
                setFieldMeta({ related_options: tmp });
              }
            }}
          >
            Set
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
